<template>
	<div class="activity-wrapper-container">
		<swiper class="activity-wrapper" :options.sync="swiperOptionTop">
			<swiper-slide class="activity-box" v-for="(item, index) in currentData" :key="index">
				<div class="activity-box-left">
					<img
						style="width: 100%; height: 100%; object-fit: cover"
						:src="item.logo169 || item.logo43 || getDefaultCover('investment_activity_169')"
					/>
				</div>
				<div class="activity-box-right">
					<svg-icons :name="`activity_title_${lang}`" class="title-icon" />
					<el-popover class="activity-code-popover" placement="bottom" trigger="hover">
						<div
							class="image"
							:ref="
								el => {
									if (el) qrCodeRefs[index] = el;
								}
							"
						></div>
						<SvgIcons slot="reference" name="activity_code" class="activity-code" />
					</el-popover>
					<div class="activity-content">
						<h4 class="text-overflow2">
							{{ item.title }}
						</h4>
						<p>
							<span class="date-text">{{ formatConferenceTime(item.date) }}</span>
							<span @click="handleCalendar(item)" class="add-calendar-text"
								>{{ $t('enterprise.activity.addCalendar')
								}}<SvgIcons name="icon_rili" class="date-icon"
							/></span>
						</p>
						<div class="status-count" v-if="showCountDown">
							<span class="status-count__line line--left"></span>
							<span class="status-count__square"></span>
							<span class="status-count__title">{{ $t('enterprise.activity.startiIn') }}</span>
							<span class="status-count__square"></span>
							<span class="status-count__line line--right"></span>
						</div>
						<!-- 倒计时 -->
						<MeetingCounter
							v-if="showCountDown"
							:time="startTime(item.date)"
							:endTime="item.date"
							@end="handleEnd(item)"
						/>
					</div>
					<div class="activity-button surf-hover-trigger" @click="viewActivity(item)">
						<span>{{ $t('enterprise.activity.meetingDetails') }}</span>
						<SvgIcons name="right-arrow" class="lang-icon-right-arrow surf-transition-arrow-rotate" />
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div slot="pagination" class="swiper-pagination"></div>
	</div>
</template>
<script setup>
import { computed } from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import { onMounted, nextTick, watch } from 'vue';
import MeetingCounter from '@/rebuild/materials/shared/investment_activity/MeetingCounter.vue';
import { useModuleDefaultCover } from '@rebuild/hooks/comp/useModuleDefaultCover';
import { useTopFive } from '@/rebuild/materials/shared/investment_activity/useTopFive';
import i18n  from '@/locales';

// 注册
SwiperCore.use([Pagination, Autoplay]);

const lang = computed(() => i18n.locale);

const {
	handleCalendar,
	startTime,
	showCountDown,
	handleEnd,
	viewActivity,
	swiperOptionTop,
	qrLink,
	qrCodeRefs,
	showQrCode,
	formatConferenceTime
} = useTopFive(props.currentData);

const { getDefaultCover } = useModuleDefaultCover();

const props = defineProps({
	currentData: {
		type: Array,
		default: () => []
	}
});

watch(
	() => props.currentData,
	val => {
		if (val.length > 0) {
			qrLink.value = val.map(item => item.descUrl);
		}
	},
	{
		immediate: true,
		deep: true
	}
);

onMounted(() => {
	nextTick(() => {
		showQrCode();
	});
});

// 监听数据变化，重新生成二维码
watch(
	() => props.currentData,
	() => {
		nextTick(() => {
			showQrCode();
		});
	},
	{ deep: true }
);

</script>

<style lang="less" scoped>
.activity-wrapper-container {
	width: 100%;
	padding-bottom: 54px;
}
.swiper-pagination {
	padding-top: 20px;
	/deep/.swiper-pagination-bullet {
		margin-right: 12px;
		background: rgba(57, 100, 229, 0.4);
	}
	/deep/.swiper-pagination-bullet-active {
		background: var(--theme-color);
	}
}
.activity-wrapper {
	border-radius: 8px;
	overflow: hidden;
	.activity-box {
		display: flex;
		height: 378px;
		border-radius: 8px;
		.activity-box-left {
			flex: 1;
			border-radius: 8px 0 0 8px;
			overflow: hidden;
		}
		.activity-box-right {
			position: relative;
			width: 330px;
			flex-shrink: 0;
			background: var(--surf-secondary-color);
			border-radius: 0 8px 8px 0;
			.title-icon {
				margin: 8px 0 0 4px;
				width: 140px;
				height: 56px;
				color: var(--surf-inverse-color)!important;
			}
			.activity-content {
				padding: 0 0 0 16px;
				h4 {
					padding: 0 16px 5px 0;
					color: var(--surf-inverse-color);
					font-size: 16px;
					font-weight: 500;
					line-height: 24px; /* 150% */
				}
				.date-text {
					padding-right: 8px;
					color: rgba(var(--surf-inverse-color-rgb), 0.4);
					font-size: 14px;
					font-weight: 400;
					line-height: 18px; /* 128.571% */
				}
				.add-calendar-text {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					color: var(--theme-color);
					font-size: 14px;
					font-weight: 400;
					line-height: 18px; /* 128.571% */
					cursor: pointer;
					color: #3964e5;
					.date-icon {
						padding-left: 4px;
						font-size: 20px;
						color: #3964e5 !important;
					}
				}
			}
			.activity-code {
				position: absolute;
				top: 0px;
				right: 0px;
				width: 38px;
				height: 38px;
				z-index: 10;
				color: var(--surf-inverse-color) !important;
			}
			.activity-button {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;
				position: absolute;
				bottom: 16px;
				left: 50%;
				transform: translateX(-50%);
				width: 298px;
				height: 36px;
				line-height: 36px;
				text-align: center;
				color: rgba(var(--surf-theme-color-rgb), 1);
				background: var(--surf-inverse-color);
				border-radius: 4px;
			}
			/deep/.meeting-counter {
				.meeting-counter__item {
					.value {
						color: var(---, #f26a3d);
						border: 1px solid rgba(var(--surf-inverse-color-rgb), 0.1);
					}
					.label {
						color: rgba(var(--surf-inverse-color-rgb), 0.6);
					}
				}
			}
		}
		.status-count {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 16px;
			margin: 32px 0 20px 0;
			&__line {
				flex: 1;
				height: 1px;
				display: inline-block;
				// 高度缩放0.5倍
				transform: scaleY(0.5);

				// 颜色渐变
				&.line {
					&--left {
						margin-right: 4px;
						background: linear-gradient(to right, rgba(242, 106, 61, 0.1), rgba(242, 106, 61, 1));
					}
					&--right {
						margin-left: 4px;
						background: linear-gradient(to right, rgba(242, 106, 61, 1), rgba(242, 106, 61, 0.1));
					}
				}
			}

			&__square {
				width: 4px;
				height: 4px;
				transform: rotate(45deg);
				background-color: rgba(242, 106, 61, 1);
			}
			&__title {
				color: #f26a3d;
				font-size: 12px;
				margin: 0 15px;
			}
		}
	}
}
.lang-icon-right-arrow {
	color: var(--theme-color) !important;
}
</style>
